<rid-spacer class="stack-cell">
  <rid-syllabic-text-input class="min-w-16" variant="STOM">
    <div class="flex place-self-center">
      <rid-vertical-spacer>
        <rid-klank-card klank="x" />
      </rid-vertical-spacer>

      <rid-algorithm-card [showDubbelzetter]="voet().hasDubbelzetter && voet().content.length === 0" />
    </div>
  </rid-syllabic-text-input>
</rid-spacer>

@let _mode = mode();
@if (_mode === 'AS_INPUT') {
  <rid-syllabic-text-input class="stack-cell min-w-16" variant="STOM" animate.enter="wait-1000 anim-pop-in">
    <div class="flex place-self-center">
      <rid-vertical-spacer>
        <rid-klank-card klank="x" />
      </rid-vertical-spacer>

      @for (k of voet().content; track $index) {
        <rid-syllabic-card [value]="k" animate.enter="anim-pop-in" />
      }

      @if (isCurrent()) {
        <rid-algorithm-card [showDubbelzetter]="voet().hasDubbelzetter && voet().content.length === 0" />
      }
    </div>
  </rid-syllabic-text-input>
} @else {
  <i-klankvoet-stom
    class="stack-cell size-24 text-rose-500"
    [showDubblezetter]="voet().hasDubbelzetter"
    animate.enter="anim-pop-in"
    animate.leave="wait-250 anim-pop-out"
  />
}
